import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, NavController } from '@ionic/angular';
import { EventProvider } from '../../../../../../../providers/event/event';
import { activities, ITeam, LineUpService, TshirtStyle } from '../../../../../lineup/services/lineup-service';
import { TournamentService, offlineUnloadKey$, PlanEnum } from '../../../../services/tournament.service';
import { SportAlgoUtils } from '../../../../services/sport.algo';
import { Router } from '@angular/router';
import { SessionProvider } from 'src/providers/session/session';

@Component({
  selector: 'plan-ko',
  templateUrl: 'plan-ko.html',
  styleUrls:['./plan-ko.scss']
})
export class PlanKoPage {
  plan = {
    id: new Date().getTime(),
    plantype: PlanEnum.KoPage,
    eventId: 0,
    sporttype: 4,
    image: null,
    name: "",
    teamNum: 2,
    games: 1,
    teams: [],
    gameTable: []
  };

  rounds = [];
  events = [];

  constructor(
    private gs: TournamentService,
    private router:Router,
    private navCtrl: NavController,
    private ls: LineUpService,
    private loader: LoadingController,
    private translate: TranslateService,
    private eventService: EventProvider,
    private sessionService:SessionProvider
  ) {
    this.getEvents();
  }

  getEvents() {
    this.eventService.getClientEvents().then(events => {
      this.events = events;
      if(events) this.plan.eventId = this.events[0].id;
    });
  }

  ionViewDidEnter() {
    this.plan.name = "Spielplan " + (this.gs.planList.length + 1);
  }

  save() {
    this.createTeams().then(async(teams) => {
      this.plan.teams = teams;
      this.createGameTable();
      let load = await this.loader.create({});
      load.present();
      this.gs.saveTou(this.plan).then(plan => {
        this.plan = plan;
        this.gs.planList.push(this.plan);
        this.gs.save();
        this.gs.$planListChangeSub.next(true);
        load.dismiss();
      });
      this.navigate();
    });
  }

  async navigate() {
    let load = await this.loader.create({});
    load.present();
    // this.app.getRootNav().getActiveChildNav().select(0);
    this.navCtrl.navigateRoot('/tab1').then(() => {
      load.dismiss();
      this.navCtrl.navigateForward('/tab1');
      // this.app.getRootNav().getActiveChildNav().select(1);
    });
  }

  createTeams() {
    return new Promise<any>((resolve, reject) => {
      let id = 0;
      this.plan.teamNum = SportAlgoUtils.squareCeil(this.plan.teamNum);
      for (let i = 0; i < this.plan.teamNum; i++) {
        let team: ITeam = {
          id: new Date().getTime() + id,
          name: 'Team ' + (i + 1),
          results: 0,
          points: 0,
          ord:id + 1,
          image: null,
          players: []
        };
        id += 1;
        this.plan.teams.push(team);
      }
      if(navigator.onLine){
        this.gs.saveTeams(this.plan.teams).then(teams => resolve(teams)).catch(err => { console.warn('oops, there is a problem while saving the teams: ' + JSON.stringify(err)); reject(); });
      }else{
        localStorage.setItem(offlineUnloadKey$, "true");
        resolve(this.plan.teams);
      }    
    });
  }

  createGameTable() {
    this.rounds = [];
    this.matchRecursive(this.plan.teamNum);

    for (let i = 0; i < this.rounds.length; i++) {
      let pre = 0;
      let id = 0;
      let arr = [];
      for (let j = 0; j < this.rounds[i]; j += 2) {
        pre = this.rounds[i] * i;

        let team1 = this.plan.teams[pre + j] ? {
          results: 0,
          points: 0,
          image: null,
          id: this.plan.teams[pre + j].id,
          name: this.plan.teams[pre + j].name,
          players: []
        }: null;

        let team2 = this.plan.teams[pre + j + 1] ? {
          results: 0,
          points: 0,
          image: null,
          id: this.plan.teams[pre + j + 1].id,
          name: this.plan.teams[pre + j + 1].name,
          players: []
        } : null;

        let gamePlan = {
          id: new Date().getTime() + id,
          type: this.plan.plantype,
          gameDay: i,
          name: this.plan.name,
          points: "0-0",
          results: "0-0",
          winner: -1,
          mapping: false,
          team1: team1,
          team2: team2
        }
        if (i != 0) {
          gamePlan.team1 = gamePlan.team2 = null;
        }
        arr.push(gamePlan);
        id += 1;
      }
      this.plan.gameTable.push(arr);
    }
  }

  onTeamNumChangeMan() {
    let n = Math.floor(Number(this.plan.teamNum));
    n = (n % 2 == 0) ? n : n + 1;
    this.plan.teamNum = n;
    this.onTeamNumChange();
  }

  onTeamNumChange() {
    this.plan.games = (this.plan.teamNum == 2) ? 1 : this.plan.teamNum;
  }

  matchRecursive(n: number): number {
    if (n <= 1) {
      return this.rounds.length;
    } else {
      this.rounds.push(n);
      return this.matchRecursive(n / 2);
    }
  }

  convert(n: number, returnValue: number) {
    return n % returnValue ? n % returnValue : returnValue;
  }

  getSportName(){
    return this.translate.instant(activities[this.plan.sporttype].path);
  }

  onAddEvent() {
    // this.app.getRootNav().getActiveChildNav().select(0);
    this.sessionService.getTokenAndNavigate(false, false).then(() => {
      // this.app.getRootNav().push(EventCreateTabsPage);
      this.navCtrl.navigateForward('/EventCreateTabsPage')
    });
  }

}




